import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';

const DescriptionConfirmation = ({ disabled, onDescriptionConfirmed }) => {
    return (<React.Fragment>
        <h3>{t('childTest.ready')}</h3>
        <p>{t('childTest.confirmText')}</p>
        <button
            className={`${styles.confirmBtn} btn main-btn`}
            onClick={onDescriptionConfirmed}
            disabled={disabled}
        >

            <i className="fa fa-check" aria-hidden /> {t('childTest.iConfirm')}
        </button>
    </React.Fragment>);
};

DescriptionConfirmation.propTypes = {
    disabled: PropTypes.bool.isRequired,
    onDescriptionConfirmed: PropTypes.func.isRequired,
};

export default DescriptionConfirmation;
